import {
	Component,
	EventEmitter,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
	selector: 'ms-overlay-panel',
	templateUrl: './ms-overlay-panel.component.html',
	styleUrls: ['./ms-overlay-panel.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsOverlayPanelComponent implements OnInit, OnDestroy {
	@ViewChild('overlayPanel')
	private _overlayPanel: OverlayPanel;

	onHide: EventEmitter<any> = new EventEmitter<any>();

	/**
	 * Constructor
	 */
	constructor() {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	toggle($event): void {
		this._overlayPanel.toggle($event);
		this._overlayPanel.onHide.subscribe(() => {
			this.onHide.emit();
		});
	}

	hide(): void {
		this._overlayPanel.hide();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
